module.exports = __webpack_public_path__ + "static/media/main idea.eb1663b4.mp3";